import { TenantEntity } from '../entity';
import { Entity } from '../entity';
import { JobSource } from './job.source';
import { JobViewFilters } from './job.filters';


export interface JobViewSummary {
    _id: string;
    name: string;
    isDefault: boolean;
    system: boolean;
    selected: boolean;
    filters?: JobViewFilters;
    ownerId?: string;
    canEditView?: boolean;
}

export enum DefaultView {
    Active = 'active',
    ActivePro = 'activepro',
    Overdue = 'overdue',
    DueIn7Days = 'duein7days',
    Unassigned = 'unassigned',
    NotDispatched = 'notdispatched',
    Closed = 'closed',
    Export = 'export',
    Empty = 'empty'
}

export interface JobView extends TenantEntity {
    description: string;
    filters: JobViewFilters;
    owner: Entity;
    isDefault?: boolean;
    isPublic?: boolean;
    system?: boolean;
    source?: JobSource;
    visibility?: JobViewVisibility;
    sharedWith?: Entity[];
    canEditView?: boolean;
}

export enum JobViewVisibility {
    Public = 'public',
    Private = 'private',
    Shared = 'shared'
}
